import _ from 'lodash';
import CuttingParameters from '@/lib/cutting-parameters.js';

var CuttingDataMixin = {
  data: function () {
    return {
      d_: 0,
      z_: 0,
      r_: 0,
      d_eff_: 0,
      d_flat_: 0,
      vc_eff_: 0,
      vc_: 0,
      vf_: 0,
      fz_: 0,
      fn_: 0,
      n_: 0,
      ft_: 0,
      ap_: 0,
      ae_: 0,
      Rz_: 0,
      Ra_: 0,
      hm_ae_: 0,
      hm_ap_: 0,
      updatedValues: [],
      dependencies: [
        {n: 'd', ns: [], ex: []},
        {n: 'd_eff', ns: ['d', 'r', 'ap'], ex: []},
        {n: 'd_flat', ns: ['d', 'r'], ex: []},
        {n: 'z', ns: [], ex: []},
        {n: 'r', ns: [], ex: []},
        {n: 'n', ns: ['vc', 'd'], ex: ['vf']},
        {n: 'n', ns: ['fz', 'z', 'vf'], ex: ['vf']},
        {n: 'vc', ns: ['n', 'd'], ex: []},
        {n: 'vc', ns: ['vc_eff', 'd', 'ap', 'r'], ex: []},
        {n: 'vf', ns: ['n', 'fn'], ex: ['n']},
        {n: 'ft', ns: ['n', 'z'], ex: []},
        {n: 'n', ns: ['ft', 'z'], ex: ['vf']},
        {n: 'fz', ns: ['vf', 'n', 'z'], ex: []},
        {n: 'fn', ns: ['fz', 'z'], ex: []},
        {n: 'vc_eff', ns: ['d', 'vc', 'ap'], ex: []},
        {n: 'Ra', ns: ['r', 'ae', 'ap'], ex: ['ae', 'ap']},
        {n: 'Rz', ns: ['r', 'ae', 'ap'], ex: ['ae', 'ap']},
        {n: 'hm_ap', ns: ['d', 'fz', 'ap'], ex: []},
        {n: 'hm_ae', ns: ['d', 'fz', 'ae'], ex: []},
        {n: 'ap', ns: [], ex: []},
        {n: 'ae', ns: ['r', 'Ra', 'ap'], ex: []},
        {n: 'ae', ns: ['r', 'Rz', 'ap'], ex: []}
      ]
    }
  },
  computed: {
    Q: function () {
      return +CuttingParameters.calc.Q(this.ap, this.ae, this.vf).toFixed(6);
    },
    P: function () {
      return +CuttingParameters.calc.P(this.ap, this.ae, this.vf).toFixed(6);
    },
    d: {
      get: function () { return +this.d_.toFixed(2); },
      set: function (d) {
        this.d_ = d;
        this.updateDependecies('d');
      }
    },
    d_flat: {
      get: function () { return +this.d_flat_.toFixed(2); },
      set: function (d_flat) {
        this.d_flat_ = d_flat;
        this.updateDependecies('d_flat');
      }
    },
    r: {
      get: function () { return +this.r_.toFixed(2); },
      set: function (r) {
        this.r_ = Math.min(this.d/2, r);
        this.updateDependecies('r');
      }
    },
    z: {
      get: function () { return +this.z_.toFixed(2); },
      set: function (z) {
        this.z_ = z;
        this.updateDependecies('z');
      }
    },
    vc: {
      get: function () { return +this.vc_.toFixed(2); },
      set: function (vc) {
        this.vc_ = vc;
        this.updateDependecies('vc');
      }
    },
    vc_eff: {
      get: function () { return +this.vc_eff_.toFixed(2); },
      set: function (vc_eff) {
        this.vc_eff_ = vc_eff;
        this.updateDependecies('vc_eff');
      }
    },
    d_eff: {
      get: function () { return +this.d_eff_.toFixed(2); },
      set: function (d_eff) {
        this.d_eff_ = d_eff;
        this.updateDependecies('d_eff');
      }
    },
    vf: {
      get: function () { return +this.vf_.toFixed(0); },
      set: function (vf) {
        this.vf_ = vf;
        this.updateDependecies('vf');
      }
    },
    fz: {
      get: function () { return +this.fz_.toFixed(4); },
      set: function (fz) {
        this.fz_ = Math.min(2 * this.r, fz);
        this.updateDependecies('fz');
      }
    },
    ap: {
      get: function () { return +this.ap_.toFixed(3); },
      set: function (ap) {
        this.ap_ = ap;
        this.updateDependecies('ap');
      }
    },
    ae: {
      get: function () { return +this.ae_.toFixed(3); },
      set: function (ae) {
        this.ae_ = Math.min(this.d, ae);
        this.updateDependecies('ae');
      }
    },
    fn: {
      get: function () { return +this.fn_.toFixed(3); },
      set: function (fn) {
        this.fn_ = fn;
        this.updateDependecies('fn');
      }
    },
    n: {
      get: function () { return +this.n_.toFixed(0); },
      set: function (n) {
        this.n_ = n;
        this.updateDependecies('n');
      }
    },
    ft: {
      get: function () { return +this.ft_.toFixed(2); },
      set: function (ft) {
        this.ft_ = ft;
        this.updateDependecies('ft');
      }
    },
    Rz: {
      get: function () { return +this.Rz_.toFixed(3); },
      set: function (Rz) {
        this.Rz_ = Rz;
        this.updateDependecies('Rz');
      }
    },
    Ra: {
      get: function () { return +this.Ra_.toFixed(3); },
      set: function (Ra) {
        this.Ra_ = Ra;
        this.updateDependecies('Ra');
      }
    },
    hm_ap: {
      get: function () { return +this.hm_ap_.toFixed(3); },
      set: function (hm_ap) {
        this.hm_ap_ = hm_ap;
        this.updateDependecies('hm_ap');
      }
    },
    hm_ae: {
      get: function () { return +this.hm_ae_.toFixed(3); },
      set: function (hm_ae) {
        this.hm_ae_ = hm_ae;
        this.updateDependecies('hm_ae');
      }
    },
  },
  methods: {
    calculate: function (name, change) {
      if (name == 'n') {
        if (change == 'ft') {
          if (this.ft && this.z) {
            this.n_ = CuttingParameters.calc.n_ft(this.ft, this.z);
            return true;
          }
        } else if (change == 'fz') {
          if (this.t && this.vf) {
            this.n_ = CuttingParameters.calc.n_fz(this.fz, this.vf, this.z);
            return true;
          }
        } else {
          if (this.vc && this.d) {
            this.n_ = CuttingParameters.calc.n(this.vc, this.d);
            return true;
          }
        }
      } else if (name == 'vc') {
        if (change == 'vc_eff') {
          if (this.d && this.d_eff) {
            this.vc_ = CuttingParameters.calc.vc_vc_eff(this.vc_eff, this.ap, this.d, this.r);
            return true;
          }
        } else {
          if (this.n && this.d) {
            this.vc_ = CuttingParameters.calc.vc(this.n, this.d);
            return true;
          }
        }
      } else if (name == 'fz') {
        if (this.vf && this.z && this.n) {
          this.fz_ = CuttingParameters.calc.fz(this.vf, this.z, this.n);
          return true;
        }
      } else if (name == 'fn') {
        if (this.fz && this.z) {
          this.fn_ = CuttingParameters.calc.fn_fz(this.fz, this.z);
          return true;
        }
      } else if (name == 'vf') {
        if (this.n && this.fn) {
          this.vf_ = CuttingParameters.calc.vf_fn(this.fn, this.n);
          return true;
        }
      } else if (name == 'ft') {
        if (this.n && this.z) {
          this.ft_ = CuttingParameters.calc.ft(this.n, this.z);
          return true;
        }
      } else if (name == 'vc_eff') {
        if (this.vc && this.d && this.ap) {
          this.vc_eff_ = CuttingParameters.calc.vc_eff(this.vc, this.ap, this.d, this.r);
          return true;
        }
      } else if (name == 'd_flat') {
        if (this.d && this.r) {
          this.d_flat_ = CuttingParameters.calc.d_flat(this.d, this.r);
          return true;
        }
      } else if (name == 'd_eff') {
        if (this.d && this.r && this.ap) {
          this.d_eff_ = CuttingParameters.calc.d_eff(this.d, this.r, this.ap);
          return true;
        }
      } else if (name == 'Ra') {
        if (this.r && this.ae && this.ap) {
          let cp = new CuttingParameters(this.r, this.ae, 0, this.ap);
          cp.computeRa();
          this.Ra_ = cp.Ra * 1e3;
          return true;
        }
      } else if (name == 'Rz') {
        if (this.r && this.ae && this.ap) {
          let cp = new CuttingParameters(this.r, this.ae, 0, this.ap);
          cp.computeRz();
          this.Rz_ = cp.Rz * 1e3;
          return true;
        }
      } else if (name == 'hm_ap') {
        if (this.fz && this.ap && this.d) {
          this.hm_ap_ = +CuttingParameters.calc.hm_ap(this.fz, this.ap, this.d).toFixed(4);
          return true;
        }
      } else if (name == 'hm_ae') {
        if (this.fz && this.ae && this.d) {
          this.hm_ae_ = +CuttingParameters.calc.hm_ae(this.fz, this.ae, this.d).toFixed(4);
          return true;
        }
      } else if (name == 'ae') {
        console.log(this.r, this.ap, this.ae);
        if (this.r && this.ap) {
          let cp = new CuttingParameters(this.r, this.ae, 0, this.ap);
          if (change == 'Rz') {
            cp.Rz = this.Rz_ * 1e-3;
            cp.computeAeFromRz();
            this.ae_ = cp.ae || 2 * this.r_;
            return true;
          } else if (change == 'Ra') {
            cp.Ra = this.Ra_ * 1e-3;
            cp.computeAeFromRa();
            this.ae_ = cp.ae || 1;
            return true;
          }
        }
      }
      return false;
    },
    updateDependecies: function (changed) {
      let updated = [changed];
      let changes = [changed];
      while (changes.length > 0) {
        let c = changes.pop();
        let deps = _.find(this.dependencies, (v) => v.n == c);
        updated = _.concat(updated, deps.ex);
        _.each(this.dependencies, ({n, ns}) => {
          if (_.includes(ns, c)) {
            if (!_.includes(updated, n)) {
              if (this.calculate(n, c)) {
                changes.push(n);
                updated.push(n);
              }
            }
          }
        });
      }
      this.updatedValues = updated;
      return updated;
    },
  },
  mounted: function () {
    _.each(this.$cuttingData, (v, k) => {
      if (this.$cuttingData[k]) {
        this[k] = this.$cuttingData[k];
      }
    });
  },
  beforeDestroy: function () {
    _.each(this.$cuttingData, (v, k) => {
      if (this[k]) {
        this.$cuttingData[k] = this[k];
      }
    });
  }
};

export default CuttingDataMixin;
